<template>
    <div style="padding: 20px">
        <vxe-form :data="formData" @submit="getTableData">
            <vxe-form-item title="状态" field="readState">
                <template #default>
                    <vxe-select v-model="formData.readState" placeholder="请选择状态" clearable>
                        <vxe-option v-for="option in readStateOptions" :value="option.code" :label="option.name"></vxe-option>
                    </vxe-select>
                </template>
            </vxe-form-item>
            <vxe-form-item>
                <template #default>
                    <vxe-button type="submit" status="primary">查询</vxe-button>
                </template>
            </vxe-form-item>
        </vxe-form>
        <vxe-table
                :data="table.tableData"
                :loading="table.loading"
                @cell-click="cellClick"
                empty-text="没有更多数据了！"
        >
            <vxe-table-column type="seq" width="60" title="序号">
            </vxe-table-column>
            <vxe-table-column
                    width="300"
                    class-name="law-title"
                    field="notice.title"
                    title="标题"
            ></vxe-table-column>
            <vxe-table-column
                    field="notice.content"
                    title="内容"
                    :formatter = 'formatContent'
            ></vxe-table-column>
            <vxe-table-column
                    width="160"
                    field="notice.publishTime"
                    title="发布时间"
            ></vxe-table-column>
            <vxe-table-column
                    width="100"
                    field="readState"
                    title="状态"
                    :formatter = 'formatState'
            >
            </vxe-table-column>
        </vxe-table>
        <!-- 分页 -->
        <vxe-pager
                background
                v-model:current-page="page.currentPage"
                v-model:page-size="page.pageSize"
                @page-change="pageChange"
                :total="page.totalResult"
                :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
        >
        </vxe-pager>
        <vxe-modal v-model="showDetails" :title="title" :show-zoom="true" @close="readNoticeHandler"
                   width="1200"  height="600"  :mask="true" :lock-view="true" :fullscreen="true"  resize>
            <template #default>
                <div class="page-wrap">
                    <div class="page-inner">
                        <h1>{{detail.notice.title}}</h1>
                        <p>{{detail.notice.content}}</p>
                    </div>
                    <div class="page-att" v-if="detail.notice.attachments && detail.notice.attachments.length > 0">
                        <a v-for="att in detail.notice.attachments" :href="att.attPath" :download="att.attName">附件：{{att.attName}}</a>
                    </div>
                </div>
                <div class="page-footer">
                    <span>留言：</span>
                    <vxe-textarea v-model="detail.readMark" placeholder="输入反馈留言" maxlength="100" show-word-count></vxe-textarea>
                </div>
            </template>
        </vxe-modal>
    </div>
</template>

<script>
    import {useStore} from "vuex";
    import {noticeList,readNotice} from "@/api/notice";
    import XEUtils from 'xe-utils'
    export default {
        name: "index",
        data(){
            return {
                store:useStore(),
                readStateOptions:[
                    {code:"1",name:"已读"},
                    {code:"0",name:"未读"},
                ],
                formData:{
                    readState:null
                },
                table:{
                    tableData:[],
                    loading:true
                },
                page:{
                    currentPage:1,
                    pageSize:10,
                    totalResult:0
                },
                showDetails:false,
                title:'',
                detail:{},
                trainState:{
                    state:0,
                    times:0,
                    startTime:null
                },
            }
        },
        created(){
            this.getTableData();
        },
        methods:{
            getTableData(){
                this.table.loading = true;
                noticeList({
                    size: this.page.pageSize,
                    current: this.page.currentPage,
                    readState:this.formData.readState
                }).then((res) => {
                    this.table.tableData = res.data.records;
                    this.page.totalResult = res.data.total;
                    this.table.loading = false;
                });
            },
            pageChange(){
                this.getTableData();
            },
            formatState(row){
                let dictList = this.readStateOptions.filter(option=> option.code === row.cellValue);
                if(dictList.length > 0){
                    return dictList[0]['name'];
                }
                return row.cellValue;
            },
            formatContent(row){
                if(row.cellValue){
                    if(row.cellValue.length > 20) return row.cellValue.slice(0,20) + '.........'
                    else return row.cellValue;
                }
                return '';
            },
            cellClick(event){
                if(event.column.property === 'notice.title'){
                    this.title = event.row.notice.title
                    this.detail = event.row;
                    this.showDetails = true
                }
            },
            readNoticeHandler(){
                let trainLog ={
                    id:this.detail.id,
                    readMark:this.detail.readMark
                };
                readNotice(trainLog).then((res)=>{
                    if(res.code === 0 ){
                        this.getTableData()
                        this.store.commit("setWorkTotal");
                    }
                })
            }
        }
    }
</script>

<style type="text/css">
    .law-title{
        color: #2d94fc;
    }
    .page-wrap{
        padding:50px 0;
        background: #eee;
        font-family: Arial, Helvetica, sans-serif;
        line-height: 20px;
    }
    .page-footer{
        margin:0 auto;
        width:800px;
    }
    .page-wrap,.page-inner,.page-att{
        margin:0 auto;
        width:600px;
        padding:50px 0 0 60px;
        background:#fff;
        /* border-radius: 20px; */
        text-align: justify;
    }
    .page-att{
        padding:0 60px 40px 0;
    }
    .page-inner{
        padding:0 60px 40px 0;
        min-height: 80vh;
    }
    .page-wrap{
        position: relative;
        /* 高斯模糊，过滤器 */
        filter:drop-shadow(0px 0px 15px #bbb);
    }
    .page-wrap:before{
        content:'';
        display: block;
        position: absolute;
        right:-60px;
        top:0;
        width:60px;
        height:50px;
        background: linear-gradient(42deg,#ddd 30%,rgba(0,0,0,0) 40%)
    }
    .page-wrap h1{
        margin-bottom: 20px;text-align:center;
        font-size: 20px;font-weight: bold;
    }
    .page-wrap p{
        text-indent: 2em;margin-bottom: 5px;
    }
</style>
